module.exports = __webpack_public_path__ + "img/shipper1.2b3132b9.png";